import { cva } from 'class-variance-authority'
import { uic, uiconfig } from '../utils'

export const buttonConfig = uiconfig({
	baseClass: [
		'inline-flex items-center justify-center gap-1.5 rounded-md text-sm font-medium whitespace-nowrap',
		'tracking-tight',
		'transition-[background-color,color,box-shadow,transform] duration-150',
		'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
		'disabled:pointer-events-none disabled:opacity-50',
		'active:translate-y-px',
		'[&>svg]:size-[15px] [&>svg]:shrink-0',
	],
	variants: {
		variant: {
			// Charcoal ink primary — quiet ink shadow that deepens on hover
			default: [
				'bg-primary text-primary-foreground',
				'shadow-[0_1px_0_0_rgba(20,20,15,0.9),0_1px_2px_0_rgba(20,20,15,0.15)]',
				'hover:shadow-[0_1px_0_0_rgba(20,20,15,0.9),0_4px_12px_-2px_rgba(20,20,15,0.25)]',
			].join(' '),
			destructive:
				'bg-destructive text-destructive-foreground shadow-[0_1px_2px_0_rgba(180,60,30,0.25)] hover:bg-destructive/90',
			outline: [
				'border border-input bg-background text-foreground',
				'shadow-[0_1px_0_0_rgba(20,20,15,0.04)]',
				'hover:bg-secondary hover:border-foreground/20',
			].join(' '),
			secondary:
				'bg-secondary border border-border text-secondary-foreground hover:bg-secondary/80',
			ghost: 'text-foreground/80 hover:bg-secondary hover:text-foreground',
			link: 'text-foreground underline underline-offset-[5px] decoration-1 decoration-foreground/40 hover:decoration-foreground',
		},
		size: {
			default: 'h-9 px-3.5 py-2',
			xs: 'h-6 rounded-sm px-2 text-xs',
			sm: 'h-8 rounded-md px-2.5 text-xs',
			lg: 'h-10 rounded-md px-6',
			icon: 'h-9 w-9',
		},
	},
	defaultVariants: {
		variant: 'default',
		size: 'default',
	},
})

export const buttonVariants = cva(buttonConfig.baseClass, {
	variants: buttonConfig.variants,
	defaultVariants: buttonConfig.defaultVariants,
})

export const Button = uic('button', buttonConfig)
export const AnchorButton = uic('a', buttonConfig)
